import React, { useState } from 'react';
import { Button } from 'antd';
import styles from './styles.scss';

const ReviewRotate = () => {
  const [ignored, setIgnored] = useState(false);

  if (ignored) {
    return null;
  }

  return (
    <div className={styles.layout}>
      <div className={styles.text}>
        Your screen may be too short to display quizzes properly. If you&apos;re on
        mobile, try rotating to portrait orientation.
      </div>
      <div className={styles.ignore}>
        <Button onClick={() => setIgnored(true)}>
          Or, ignore this and proceed anyway
        </Button>
      </div>
    </div>
  );
};

export default ReviewRotate;
